import { jsx as _jsx } from "react/jsx-runtime";
import { WebElement } from 'z3k-config';
import { useZ3KObjectState } from 'console/shared/hooks/device/z3k';
import { memo, useMemo } from 'react';
import { CustomControlContent } from './types';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
export const Z3KCustomControlProvider = memo(function Z3KCustomControlProvider(props) {
    const { custom_control_config, children } = props;
    const { device_id } = useDeviceConfig();
    const { id, labels, type } = custom_control_config;
    const { active_label, inactive_label } = labels || {};
    const { state: state_value } = useZ3KObjectState(id);
    const is_active = state_value === 1;
    const current_label = is_active || type === WebElement.Type.SIMPLE ? active_label : inactive_label;
    const status = useAppSelector((state) => state.z3k_custom_command?.by_device_id?.[device_id])?.[id];
    const different_custom_control_state = useMemo(() => {
        switch (type) {
            case WebElement.Type.STATUS:
                return { current_label, is_active, state_value };
            case WebElement.Type.SIMPLE:
                return { action_label: current_label, is_active, state_value };
            case WebElement.Type.ANALOG:
                return { state_value };
            default:
                return { is_active, action_label: current_label, state_value };
        }
    }, [current_label, is_active, state_value]);
    const custom_control_state = useMemo(() => ({
        ...different_custom_control_state,
        loading: status?.loading ?? false,
        fail: status?.fail ?? false,
        fail_message: status?.fail_message ?? '',
    }), [status, different_custom_control_state]);
    const custom_control = useMemo(() => ({
        ...custom_control_config,
        ...custom_control_state,
    }), [custom_control_config, custom_control_state]);
    return (_jsx(CustomControlContent.Provider, { value: custom_control, children: children }));
});
